
export class ByteUtils
{
    public static HumanReadable(sizeInBytes: number): string
    {
        if (sizeInBytes < 1024*1024)
            return (sizeInBytes / 1024).toFixed(0) + "kB";
        else if (sizeInBytes < 1024 * 1024 * 1024)
            return (sizeInBytes / 1024 / 1024).toFixed(1) + "MB";
        else
            return (sizeInBytes / 1024 / 1024 / 1024).toFixed(2) + "GB";
    }
}
